export default {
  "common.colon": "：",
} as const;
